'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest from "./app.data.-App-Document-Lineage-Request.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentLineageRequest$FromParents(parents) {
  this.a8t = null;
  this.a8t = parents;
}
export { $c_Lapp_data_AppDocumentLineageRequest$FromParents as $c_Lapp_data_AppDocumentLineageRequest$FromParents };
$p = $c_Lapp_data_AppDocumentLineageRequest$FromParents.prototype = new $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest.$h_Lapp_data_AppDocumentLineageRequest();
$p.constructor = $c_Lapp_data_AppDocumentLineageRequest$FromParents;
/** @constructor */
function $h_Lapp_data_AppDocumentLineageRequest$FromParents() {
}
export { $h_Lapp_data_AppDocumentLineageRequest$FromParents as $h_Lapp_data_AppDocumentLineageRequest$FromParents };
$h_Lapp_data_AppDocumentLineageRequest$FromParents.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentLineageRequest$FromParents)) {
    var x = this.a8t;
    var x$2 = x$0.a8t;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "FromParents";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a8t;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "parents";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_AppDocumentLineageRequest$FromParents(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j5)));
}
export { $isArrayOf_Lapp_data_AppDocumentLineageRequest$FromParents as $isArrayOf_Lapp_data_AppDocumentLineageRequest$FromParents };
var $d_Lapp_data_AppDocumentLineageRequest$FromParents = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentLineageRequest$FromParents, "app.data.AppDocumentLineageRequest$FromParents", ({
  j5: 1,
  fQ: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentLineageRequest$FromParents as $d_Lapp_data_AppDocumentLineageRequest$FromParents };
//# sourceMappingURL=app.data.-App-Document-Lineage-Request$-From-Parents.js.map
